import { TableCell, TableRow, Tooltip } from '@mui/material';
import { Icons, Images } from 'assets';
import styles from "pages/phNewPendingTasks/style.module.scss";
import moment from 'moment';
import { user_roles } from 'shared/utils/constants';
import Popover from "shared/components/PopOver";

const ReportedBooks = () => {
    const tasksList = [
      {
        role: 1,
        status: 1,
        cover: 1,
      },
      {
        role: 2,
        status: 2,
        cover: 0,
      },
    ];
  
    return (
      <>
        {tasksList?.map((item: any, index: any, arr: any) => {
          return (
            <TableRow
            // className={classNames(index + 1 === arr.length && styles.lastCells)}
            >
              <TableCell>
                <div className={styles.nameCell}>
                  <img
                    src={Images.BookSample1}
                    alt="profile_picture"
                    className={styles.bookImg}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Harry Potter</label>
                    <label className={styles.emailLabel}>JK Rowlings</label>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                <div className={styles.nameCell}>
                  <img
                    src={Images.UserPlaceholderImage}
                    alt="profile_picture"
                    className={styles.profilepic}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Ehya Publication</label>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                {item?.role === user_roles.author
                  ? "Author"
                  : item?.role === user_roles.parent
                  ? "Parent"
                  : item?.role === user_roles.publisher
                  ? "Publisher"
                  : item?.role === user_roles.reader
                  ? "Reader"
                  : item?.role === user_roles.school
                  ? "School"
                  : item?.role === user_roles.teacher
                  ? "Teacher"
                  : ""}
              </TableCell>
              <TableCell>{moment(new Date()).format("MMM DD, YYYY")}</TableCell>
              <TableCell>
                <Popover reason={"Copyrighted my content without permission"} />
              </TableCell>
              <TableCell>
                <div className={styles.actionContainer}>
                  <Tooltip arrow title="View Book">
                    <div>
                      <Icons.EyeIcon className={styles.icons} />
                    </div>
                  </Tooltip>
  
                  <Tooltip arrow title={"Approve"}>
                    <div>
                      <Icons.ApproveIcon />
                    </div>
                  </Tooltip>
                  <Tooltip arrow title={"Reject"}>
                    <div>
                      <Icons.RejectIcon />
                    </div>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };
  

export default ReportedBooks
